import { Model, RailsFormat } from "./model"

export class DirectDebitSummary extends Model {

  constructor(
    public id?: number,
    public termId?: number,
    public instalment: number = null,
    public description: string = null,

    public batched: number = null,
    public batchedApproved: number = null,
    public batchedDeclined: number = null,
    public unbatched: number = null,
    public unprocessable: number = null,
    public processable: number = null,

    public batchedCount: number = null,
    public batchedApprovedCount: number = null,
    public batchedDeclinedCount: number = null,
    public unbatchedCount: number = null,
    public unprocessableCount: number = null,
    public processableCount: number = null,

    public unbatchedRecovered: number = null,
    public unbatchedOutstanding: number = null,
    public unbatchedDisenroled: number = null,
    public declinedRecovered: number = null,
    public declinedOutstanding: number = null,
    public declinedDisenroled: number = null,
    public approvedReceived: number = null,
    public approvedRefunded: number = null,
    public approvedDisenroled: number = null,

    public unbatchedRecoveredCount: number = null,
    public unbatchedOutstandingCount: number = null,
    public unbatchedDisenroledCount: number = null,
    public declinedRecoveredCount: number = null,
    public declinedOutstandingCount: number = null,
    public declinedDisenroledCount: number = null,
    public approvedReceivedCount: number = null,
    public approvedRefundedCount: number = null,
    public approvedDisenroledCount: number = null,

    public createdAt: Date = null,
    public updatedAt: Date = null,
  ) { super() }

  static clone(obj: any) {
    const o = new this()

    if (obj.id) { o.id = obj.id }
    if (obj.termId) { o.termId = obj.termId }
    if (obj.instalment != undefined) { o.instalment = obj.instalment }
    if (obj.description) { o.description = obj.description }

    if (obj.batched != undefined) { o.batched = obj.batched }
    if (obj.batchedApproved != undefined) { o.batchedApproved = obj.batchedApproved }
    if (obj.batchedDeclined != undefined) { o.batchedDeclined = obj.batchedDeclined }
    if (obj.unbatched != undefined) { o.unbatched = obj.unbatched }
    if (obj.unprocessable != undefined) { o.unprocessable = obj.unprocessable }
    if (obj.processable != undefined) { o.processable = obj.processable }

    if (obj.batchedCount != undefined) { o.batchedCount = obj.batchedCount }
    if (obj.batchedApprovedCount != undefined) { o.batchedApprovedCount = obj.batchedApprovedCount }
    if (obj.batchedDeclinedCount != undefined) { o.batchedDeclinedCount = obj.batchedDeclinedCount }
    if (obj.unbatchedCount != undefined) { o.unbatchedCount = obj.unbatchedCount }
    if (obj.unprocessableCount != undefined) { o.unprocessableCount = obj.unprocessableCount }
    if (obj.processableCount != undefined) { o.processableCount = obj.processableCount }

    if (obj.unbatchedRecovered != undefined) {
      o.unbatchedRecovered = obj.unbatchedRecovered }

    if (obj.unbatchedOutstanding != undefined) {
      o.unbatchedOutstanding = obj.unbatchedOutstanding }

    if (obj.unbatchedDisenroled != undefined) {
      o.unbatchedDisenroled = obj.unbatchedDisenroled }

    if (obj.declinedRecovered != undefined) {
      o.declinedRecovered = obj.declinedRecovered }

    if (obj.declinedOutstanding != undefined) {
      o.declinedOutstanding = obj.declinedOutstanding }

    if (obj.declinedDisenroled != undefined) {
      o.declinedDisenroled = obj.declinedDisenroled }

    if (obj.approvedReceived != undefined) {
      o.approvedReceived = obj.approvedReceived }

    if (obj.approvedRefunded != undefined) {
      o.approvedRefunded = obj.approvedRefunded }

    if (obj.approvedDisenroled != undefined) {
      o.approvedDisenroled = obj.approvedDisenroled }


    if (obj.unbatchedRecoveredCount != undefined) {
      o.unbatchedRecoveredCount = obj.unbatchedRecoveredCount }

    if (obj.unbatchedOutstandingCount != undefined) {
      o.unbatchedOutstandingCount = obj.unbatchedOutstandingCount }

    if (obj.unbatchedDisenroledCount != undefined) {
      o.unbatchedDisenroledCount = obj.unbatchedDisenroledCount }

    if (obj.declinedRecoveredCount != undefined) {
      o.declinedRecoveredCount = obj.declinedRecoveredCount }

    if (obj.declinedOutstandingCount != undefined) {
      o.declinedOutstandingCount = obj.declinedOutstandingCount }

    if (obj.declinedDisenroledCount != undefined) {
      o.declinedDisenroledCount = obj.declinedDisenroledCount }

    if (obj.approvedReceivedCount != undefined) {
      o.approvedReceivedCount = obj.approvedReceivedCount }

    if (obj.approvedRefundedCount != undefined) {
      o.approvedRefundedCount = obj.approvedRefundedCount }

    if (obj.approvedDisenroledCount != undefined) {
      o.approvedDisenroledCount = obj.approvedDisenroledCount }

    return o
  }

}




// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/direct-debit-summary.ts